<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u7IGY0/tc-custom/9781504065245.jpg?1726574100485" alt="This image is the cover for the book Mysteries of Robert Louis Stevenson"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mysteries of Robert Louis Stevenson
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A short thriller and a comic crime novel by the author of <i>The Strange Case of Dr. Jekyll and Mr. Hyde</i> explore murderous greed in nineteenth-century Scotland.</b></p><p><i>The Wrong Box</i>: Two elderly brothers, Joseph and Masterman, are the last surviving members of an investment agreement known as a tontine. All their two nephews have to do to inherit everything is make sure Joseph outlives Masterman. But that’s easier said than done. Robert Louis Stevenson cowrote this comic crime novel with his stepson Lloyd Osbourn.</p><p><i>The Body Snatcher</i>: Inspired by the notorious Burke and Hare murders, this chilling short story tells the tale of two medical students in charge of receiving human cadavers for dissection in their anatomy class. When one of them begins to suspect murder is afoot, the other starts acting increasingly suspicious—until both find themselves in a terrifying predicament.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Louis Stevenson
      </h2>
      
      <p class="authorDescription body article">Robert Louis Stevenson (1850&ndash;1894) was a Scottish novelist, travel writer, poet, and children&rsquo;s author. Plagued by poor health his entire life, he was nevertheless an amazingly prolific writer, and created some of the most influential and entertaining fiction of the nineteenth century, including&#160;<I>Treasure Island</I>,&#160;<I>Kidnapped</I>, and&#160;<I>The Strange Case of Dr. Jekyll and Mr. Hyde</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fbc0000